import React, { FC } from 'react';
import { WrappedFieldProps } from 'redux-form';
import { Input } from '@brg/input';
import { FlexBox } from '@brg/ui';
import styled from 'styled-components';
import { GridRow } from '../../../pages/CompetitionApplicationForm/components/styles';
import { FormLabel } from '../../../modals/styles';
import { LabelRedStar } from '../../../pages/designerEditView/styles';

const CheckboxContainer = styled(FlexBox)`
  width: 610px;
  position: relative;
  
  .checkbox-with-label {
    div:last-child {
      white-space: nowrap;
      color: rgba(144, 144, 144, 1);
      font-size: 17px;
      line-height: 22px;
      font-weight: 400;
    }

    div {
      min-width: auto;
    }
  }
  
 input{
  width: 32px;
  height: 32px;
  max-width: 32px;
  min-width: auto;
 }
`;

const AgreementText = styled.div`
  font-size: 15px;
  line-height: 20px;
  color: #151514;
  
  a {
    color: #30363A;
    text-decoration: underline;
    
    &:hover {
      color: #000;
      text-decoration: none;
    }
  }
`;

const AgreementLink = styled.span`
  color: #30363A;
  text-decoration: underline;
  cursor: pointer;
  
  &:hover {
    color: #000;
    text-decoration: none;
  }
`;

interface AgreementCheckboxProps extends WrappedFieldProps {
  label: string;
  required?: boolean;
}

const AgreementCheckbox: FC<AgreementCheckboxProps> = ({
  input: { onChange, value },
  meta: { touched, error },
  label,
  required,
}) => {
    const handleLinkClick = (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      window.open('https://hsedesign.ru/', '_blank', 'noopener,noreferrer');
    };

  return (
    <GridRow isTeamEdit>
      <FormLabel isTeamEdit>
        {label}
        {required && <LabelRedStar>*</LabelRedStar>}
      </FormLabel>
      <CheckboxContainer direction="row" align="center" offsetTop={8}>
        <Input.Checkbox
          checked={value}
          onChange={onChange}
          title=""
          className="competition-checkbox"
        />
        <FlexBox offsetLeft={12} align="center">
          <AgreementText>
            Я принимаю{' '}
            <AgreementLink onClick={handleLinkClick}>
              пользовательское соглашение платформы
            </AgreementLink>
          </AgreementText>
        </FlexBox>
      </CheckboxContainer>
      {touched && error && (
        <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
          {error}
        </div>
      )}
    </GridRow>
  );
};

export default AgreementCheckbox; import React, { FC } from 'react';
import { WrappedFieldProps } from 'redux-form';
import { Input } from '@brg/input';
import { FlexBox } from '@brg/ui';
import styled from 'styled-components';
import { GridRow } from '../../../pages/CompetitionApplicationForm/components/styles';
import { FormLabel } from '../../../modals/styles';
import { LabelRedStar } from '../../../pages/designerEditView/styles';

const CheckboxContainer = styled(FlexBox)`
  width: 610px;
  position: relative;
  
  .checkbox-with-label {
    div:last-child {
      white-space: nowrap;
      color: rgba(144, 144, 144, 1);
      font-size: 17px;
      line-height: 22px;
      font-weight: 400;
    }

    div {
      min-width: auto;
    }
  }
  
 input{
  width: 32px;
  height: 32px;
  max-width: 32px;
  min-width: auto;
 }
`;

const AgreementText = styled.div`
  font-size: 15px;
  line-height: 20px;
  color: #151514;
  
  a {
    color: #30363A;
    text-decoration: underline;
    
    &:hover {
      color: #000;
      text-decoration: none;
    }
  }
`;

const AgreementLink = styled.span`
  color: #30363A;
  text-decoration: underline;
  cursor: pointer;
  
  &:hover {
    color: #000;
    text-decoration: none;
  }
`;

interface AgreementCheckboxProps extends WrappedFieldProps {
  label: string;
  required?: boolean;
}

const AgreementCheckbox: FC<AgreementCheckboxProps> = ({
  input: { onChange, value },
  meta: { touched, error },
  label,
  required,
}) => {
    const handleLinkClick = (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      window.open('https://hsedesign.ru/', '_blank', 'noopener,noreferrer');
    };

  return (
    <GridRow isTeamEdit>
      <FormLabel isTeamEdit>
        {label}
        {required && <LabelRedStar>*</LabelRedStar>}
      </FormLabel>
      <CheckboxContainer direction="row" align="center" offsetTop={8}>
        <Input.Checkbox
          checked={value}
          onChange={onChange}
          title=""
          className="competition-checkbox"
        />
        <FlexBox offsetLeft={12} align="center">
          <AgreementText>
            Я принимаю{' '}
            <AgreementLink onClick={handleLinkClick}>
              пользовательское соглашение платформы
            </AgreementLink>
          </AgreementText>
        </FlexBox>
      </CheckboxContainer>
      {touched && error && (
        <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
          {error}
        </div>
      )}
    </GridRow>
  );
};

export default AgreementCheckbox; 